export default {"src":"/_next/static/media/logoemtsitter.fffde9b6.svg","height":46,"width":167,"blurWidth":0,"blurHeight":0};